import { GAS_STATION_KEY } from "@store/memberCenterSlice";
import { formatNumberNormal } from "@utils/format";
import { CURRENCY_SYMBOL, REGION_TO_CURRENCY } from "@src/config/country";
import { gasStation } from "./config";

export const formatCurrency = (
  number: number,
  region: any,
  currency: string,
  language: string,
  isLocalCurrency?: boolean,
) => {
  if (number) {
    // @ts-ignore
    if (
      REGION_TO_CURRENCY[region] === currency ||
      REGION_TO_CURRENCY[region]?.includes?.(currency) ||
      isLocalCurrency
    ) {
      if (currency === "JPY") {
        return formatNumberNormal(number, language === "id-ID") + CURRENCY_SYMBOL[currency];
      }
      return CURRENCY_SYMBOL[currency] + formatNumberNormal(number, language === "id-ID");
    } else {
      return "$" + formatNumberNormal(number, language === "id-ID");
    }
  }
  return "";
};

export const getGasStationPrice = (key: GAS_STATION_KEY, region: string, currency: string, usPrice: any) => {
  if (REGION_TO_CURRENCY[region] === currency) {
    return gasStation[key]["price"][region] || usPrice;
  } else {
    return gasStation[key]["price"]["US"] || usPrice;
  }
};

export const splitPrice = (price: string) => {
  const regex = /([^\d]+)?([\d,.]+)([^\d]+)?/;
  const match = price.match(regex) || [null, null, null];
  const replaceArr = [match[1], match[2], match[3]];
  return replaceArr;
};

export const isMutipleRegion = (selectCountryKey: string) => {
  return ["Global", "Southeast Asia", "Ameu"].includes(selectCountryKey);
};
